/* eslint-disable quote-props */
/* eslint-disable react/react-in-jsx-scope */
import { Tab, TabProps } from "@mui/material";

interface ITabCustomProps extends TabProps {
  label: string;
  value: string;
}

const TabCustom = ({ label, value, sx, ...other }: ITabCustomProps) => {
  return (
    <Tab
      {...other}
      aria-label={`${label}-tab`}
      label={label}
      value={value}
      sx={{
        flexGrow: { xs: 1, md: 0 },
        width: { xs: "auto", md: "195px" },
        textTransform: "none",
        color: "black.main",
        minHeight: "32px",
        height: "32px",
        padding: "6px",
        "&.Mui-selected": {
          backgroundColor: (theme) => theme.palette.primary.dark,
          fontWeight: 600,
          color: "black.main",
        },
        ...sx,
      }}
    />
  );
};

export default TabCustom;
